const release2022 = [
  {
    date: '2022-12-30',
    items: [
      {
        type: 'Added',
        summary:
        <>
          - 온라인상품: 등록/수정/리스트조회/상세조회 API v1.1 추가 <br/>
          - SKU상품: 등록/수정/상세조회 API v1.2 추가 <br/>
          <h6 style={{ color: 'red' }}>* 신규 버전 이전 API들은 추후 솔루션 (구)상품정보제공고시 사용 불가능 시 사용 불가능 예정</h6>
        </>,
        apis: [
          {
            method: 'POST',
            action: '/online/list/v1.1',
          },
          {
            method: 'GET',
            action: '/products/:ol_shop_no/v1.1',
          },
          {
            method: 'POST',
            action: '/products/add/v1.1',
          },
          {
            method: 'PUT',
            action: '/products/edit/v1.1',
          },
          {
            method: 'GET',
            action: '/stock/:sku_cd/v1.2',
          },
          {
            method: 'POST',
            action: '/stock/add/v1.2',
          },
          {
            method: 'PUT',
            action: '/stock/edit/v1.2',
          }
        ]
      }
    ]
  },
  {
    date: '2022-12-14',
    items: [
      {
        type: 'Changed',
        summary:
        <>
          출고 보류 API 명칭 변경 및 파라미터 추가
        </>,
        apis: [
          {
            method: 'PUT',
            action: '/order/hold',
            detail:
            <>
              출고 보류 API 명칭 변경 <code>출고보류</code> { '=>' } <code>보류</code><br />
              status parameter 추가
            </>
          }
        ]
      }
    ]
  },
  {
    date: '2022-12-13',
    items: [
      {
        type: 'Added',
        summary:
        <>
          온라인상품 판매수량 수정 API 추가
        </>,
        apis: [
          {
            method: 'PATCH',
            action: '/products/sale-cnt',
          }
        ]
      }
    ]
  },
  {
    date: '2022-11-14',
    items: [
      {
        type: 'Changed',
        summary:
        <>
          주문 리스트 조회 API <code>date_type</code> 에 <code>api_read_time</code> 추가
        </>,
        apis: [
          {
            method: 'POST',
            action: '/orders'
          }
        ]
      }
    ]
  },
  {
    date: '2022-10-14',
    items: [
      {
        type: 'Changed',
        summary:
        <>
          정산내역 조회 API 정산 주문 번호 필드 <code>shop_ord_no_seq</code> 삭제
        </>,
        apis: [
          {
            method: 'POST',
            action: '/calculate/list',
          }
        ]
      },
      {
        type: 'Added',
        summary:
        <>
          작업 삭제 API 추가
        </>,
        apis: [
          {
            method: 'DELETE',
            action: '/work/delete/v1.1'
          }
        ]
      }
    ]
  },
  {
    date: '2022-10-12',
    items: [
      {
        type: 'Changed',
        summary:
        <>
          - 머리말/꼬리말 템플릿 조회 API 템플릿 종류 항목<code>addcontentTarget</code> 추가<br/>
          - 온라인상품관련 API 상품명 머리말/꼬리말 템플릿 번호 <code>shop_sale_name, addcontent_no</code> 항목 추가
        </>,
        apis: [
          {
            method: 'GET',
            action: '/addcontents',
          },
          {
            method: 'GET',
            action: '/products/:ol_shop_no/v1.1',
          },
          {
            method: 'PUT',
            action: '/products/edit/v1.1',
          },
          {
            method: 'POST',
            action: '/products/add/v1.1',
          }
        ]
      },
    ]
  },
  {
    date: '2022-09-30',
    items: [
      {
        type: 'Changed',
        summary:
        <>
          주문 등록 API 직업 입력 쇼핑몰 지원<br/>
          - <code>custom_shop_cd, custom_shop_id</code>
        </>,
        apis: [
          {
            method: 'POST',
            action: '/order/add',
          }
        ]
      }
    ]
  },
  {
    date: '2022-09-27',
    items: [
      {
        type: 'Changed',
        summary:
        <>
          상품 리스트 조회 API v1.1 옵션 출력 정보 추가 및 선택작업 등록(상품) 응답 추가
        </>,
        apis: [
          {
            method: 'POST',
            action: '/products/online/list/v1.1',
            detail:
            <>
              옵션 출력 정보 <code>pack_unit, set_name, prod_name</code>등 추가
            </>
          },
          {
            method: 'POST',
            action: '/work/addWorkSelect',
            detail:
            <>
              상품 작업인 경우 <code>api_callback_url</code> 설정 시 리턴되는 정보에 <code>product_info</code> 추가<br />
              - <code>c_sale_cd</code>: 판매자관리코드, <code>shop_sale_no</code>: 쇼핑몰상품코드
            </>
          }
        ]
      },
    ]
  },
  {
    date: '2022-09-21',
    items: [
      {
        type: 'Changed',
        summary:
        <>
          상품리스트 조회 API v1.1 멀티 검색 입력값 포맷 변경
        </>,
        apis: [
          {
            method: 'POST',
            action: '/products/online/list/v1.1',
            detail:
            <>
              - v1.1 버전만 변경
              - <code>String</code> { '=>' } <code>String[]</code>
            </>
          }
        ]
      }
    ]
  },
  {
    date: '2022-08-22',
    items: [
      {
        type: 'Changed',
        summary:
        <>
          상품리스트 조회 API 상품 갯수 제한
        </>,
        apis: [
          {
            method: 'POST',
            action: '/products/online/list/v1.1',
            detail:
            <>
              - 호출정보 length: MAX 300<br />
              - 결과 데이터 변경없음
            </>
          }
        ]
      }
    ]
  },
  {
    date: '2022-08-18',
    items: [
      {
        type: 'Added',
        summary:
        <>
          상품리스트 조회 API v1.1 추가
        </>,
        apis: [
          {
            method: 'GET',
            action: '/products/online/list/v1.1',
            detail:
            <>
              - 호출정보 변경없음<br />
              - 결과 데이터 변경 (옵션, 품목정보고시 정보 추가)
            </>
          }
        ]
      }
    ]
  },
  {
    date: '2022-07-22',
    items: [
      {
        type: 'Changed',
        summary:
        <>
          SKU상품 등록 API v1.1 파라미터 정리
        </>,
        apis: [
          {
            method: 'POST',
            action: '/stock/add/v1.1',
            detail:
            <>
              - 대표 배송처 파라미터 위치 변경<br />
              - v.1.1 버전에 사용되지 않는 파라미터 <code>delivery_vendor</code> 삭제
            </>
          }
        ]
      }
    ]
  },
  {
    date: '2022-07-19',
    items: [
      {
        type: 'Added',
        summary:
        <>
          로그 조회 API 추가  
        </>,
        apis: [
          {
            method: 'GET',
            action: '/logs/v1.1',
          }
        ]
      }
    ]
  },
  {
    date: '2022-07-14',
    items: [
      {
        type: 'Added',
        summary:
        <>
          주문 수정 API v1.1 추가
        </>,
        apis: [
          {
            method: 'PUT',
            action: '/order/edit/v1.1',
          }
        ]
      }
    ]
  },
  {
    date: '2022-07-04',
    items: [
      {
        type: 'Changed',
        summary:
        <>
          작업 등록 API v1.1 <code>api_callback_url</code> 파라미터 추가
        </>,
        apis: [
          {
            method: 'POST',
            action: '/work/addWork/v1.1',
            detail:
            <>
              - 작업 등록 시 <code>api_callback_url</code> 를 입력하시면 작업 완료 시 입력한 주소로 작업결과가 전송됩니다.
            </>
          }
        ]
      }
    ]
  },
  {
    date: '2022-06-28',
    items: [
      {
        type: 'Added',
        summary:
        <>
          다중 배송처 적용으로 인한 SKU상품 등록/수정/상세조회/재고수정 v1.1 추가
        </>,
        apis: [
          {
            method: 'GET',
            action: '/stock/:sku_cd/v1.1'
          },
          {
            method: 'PUT',
            action: '/stock/manage/v1.1'
          },
          {
            method: 'PUT',
            action: '/stock/edit/v1.1'
          },
          {
            method: 'POST',
            action: '/stock/add/v1.1'
          }
        ]
      },
    ]
  },
  {
    date: '2022-06-23',
    items: [
      {
        type: 'Changed',
        summary:
        <>
          주문 리스트 조회 API 파라미터 추가
        </>,
        apis: [
          {
            method: 'POST',
            action: '/orders',
            detail:
            <>
              - <code>api_read_status</code>, 응답 필드: <code>api_read_time, api_read_status</code> <br/>
              - api_read_status 로 api를 통해 호출/미호출 주문 조회 지원
            </>
          }
        ]
      }
    ]
  },
  {
    date: '2022-05-26',
    items: [
      {
        type: 'Added',
        summary:
        <>
          합포장 API 추가
        </>,
        apis: [
          {
            method: 'PUT',
            action: '/order/combine'
          }
        ]
      },
      {
        type: 'Changed',
        summary:
        <>
          주문 등록 API 결과값에 등록한 주문의 <code>uniq</code> 추가
        </>,
        apis: [
          {
            method: 'POST',
            action: '/order/add',
          }
        ]
      }
    ]
  },
  {
    date: '2022-04-06',
    items: [
      {
        type: 'Added',
        summary:
        <>
          hscd 코드 조회 API 추가
        </>,
        apis: [
          {
            method: 'GET',
            action: '/hscds'
          }
        ]
      },
      {
        type: 'Changed',
        summary:
        <>
          - <code>기초상품</code>{ '=>' }<code>SKU상품</code> 명칭 변경<br />
          - <code>hscd</code> 필드 추가
        </>,
        apis: [
          {
            method: 'PUT',
            action: '/stock/edit',
          },
          {
            method: 'GET',
            action: '/stock/:sku_cd',
          },
          {
            method: 'POST',
            action: '/stock/add',
          }
        ]
      },
    ]
  },
  {
    date: '2022-03-31',
    items: [
      {
        type: 'Changed',
        summary:
        <>
          주문 리스트 조회 API 마스킹 처리 여부 <code>masking_yn</code> 추가
        </>,
        apis: [
          {
            method: 'POST',
            action: '/orders'
          }
        ]
      }
    ]
  },
  {
    date: '2022-02-16',
    items: [
      {
        type: 'Changed',
        summary:
        <>
          온라인상품등록 결과값에 쇼핑몰 정보 추가
        </>,
        apis: [
          {
            method: 'POST',
            action: '/products/add',
            detail: <>
              <pre style={{ width: '500px' }}>
                <code>
                  {`site_list: [
                    {
                        "shop_name",
                        "shop_cd",
                        "shop_id",
                        "ol_shop_no",
                    }
                  ]`}
                </code>
              </pre>
            </>
          }
        ]
      }
    ]
  },
  {
    date: '2022-01-10',
    items: [
      {
        type: 'Changed',
        summary:
        <>
          주문 리스트 조회 API 적용된 규칙사은품 정보 <code>gift_rule</code> 추가  
        </>,
        apis: [
          {
            method: 'POST',
            action: '/orders',
          }
        ]
      }
    ]
  }
]

export default release2022;